module.exports = __webpack_public_path__ + "static/gotland-images-1-1c4b28a8c61e6ca2032cfef105f71a1a.jpg";